import React, { useState, useEffect, Fragment } from 'react';
import { Space, Typography } from 'antd';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { formatCoverageValue } from 'Utils';
import { SUCCESS_COLOR, ERROR_COLOR } from '@shared/constants/colors';

const { Text } = Typography;

export const ListCoverages = ({
  coverages,
  assists,
  insurancePackage,
  showAll = true,
}) => {
  const [coveragesSerialized, setCoveragesSerialized] = useState([]);
  const [assistsSerialized, setAssistsSerialized] = useState([]);
  const [otherCoverages, setOtherCoverages] = useState([]);

  useEffect(() => {
    // Serializer las coberturas del paquete dependiendo de las devueltas por el server
    const newCoveragesSerialized = coverages.filter((item) => showAll ? true : item.main).map((globalCoverage) => {
      const filteredCoverage = insurancePackage.coverages.find((packageCoverage) => globalCoverage.id ? (packageCoverage.id === globalCoverage.id) : (packageCoverage.name === globalCoverage.name));
      return {
        id: globalCoverage.id || globalCoverage.name,
        name: globalCoverage.name,
        value: filteredCoverage ? formatCoverageValue(filteredCoverage.insured_value) : null,
        hasThisCoverage: !!filteredCoverage,
        deductible: filteredCoverage?.deductible,
      };
    }).sort((a, b) => (a.hasThisCoverage === b.hasThisCoverage) ? 0 : a.hasThisCoverage ? -1 : 1);
    setCoveragesSerialized(newCoveragesSerialized);

    // Serializer las asistencias del paquete dependiendo de las devueltas por el server
    const newAssistsSerialized = assists.filter((item) => showAll ? true : item.main).map((globalAssist) => {
      const filteredAssist = insurancePackage.assists.find((packageAssist) => globalAssist.id ? (packageAssist.id === globalAssist.id) : (packageAssist.name === globalAssist.name));
      return {
        id: globalAssist.id || globalAssist.name,
        name: globalAssist.name,
        value: filteredAssist ? formatCoverageValue(filteredAssist.insured_value) : null,
        hasThisCoverage: !!filteredAssist,
        deductible: filteredAssist?.deductible,
      };
    }).sort((a, b) => (a.hasThisCoverage === b.hasThisCoverage) ? 0 : a.hasThisCoverage ? -1 : 1);
    setAssistsSerialized(newAssistsSerialized);

    if (insurancePackage.other_coverages.length > 0) {
      const newOtherCoveragesSerialized = insurancePackage.other_coverages.filter((item) => showAll ? true : item.main).map((globalCoverage) => {
        return {
          id: globalCoverage.id || globalCoverage.name,
          name: globalCoverage.name,
          value: formatCoverageValue(globalCoverage.insured_value),
          hasThisCoverage: true,
          deductible: globalCoverage?.deductible,
        }
      }).sort((a, b) => (a.hasThisCoverage === b.hasThisCoverage) ? 0 : a.hasThisCoverage ? -1 : 1);
      setOtherCoverages(newOtherCoveragesSerialized);
    }
  }, [coverages, assists, insurancePackage]);

  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {showAll ?
        <Text strong>Coberturas</Text>
        : null
      }
      {coveragesSerialized.map((coverage) => (
        <li key={coverage.id} style={{ marginBottom: '5px', display: 'flex' }}>
          <span style={{ width: '30px' }}>
            {coverage.hasThisCoverage ? (
              <FontAwesomeIcon icon={faCheck} style={{ color: SUCCESS_COLOR }} />
            ) : (
              <FontAwesomeIcon icon={faXmark} style={{ color: ERROR_COLOR }} />
            )}
          </span>
          <span>
            {coverage.hasThisCoverage ? (
              <p style={{ margin: 0 }}>
                <Space size='middle'>
                  <Text>{coverage.name}</Text>
                  {showAll && (<>
                    {!!coverage.value && <Text><Text strong>Límite: </Text>{coverage.value}</Text>}
                    {!!coverage.deductible && <Text><Text strong>Deducible: </Text>{coverage.deductible}</Text>}
                  </>)}
                </Space>
              </p>
            ) : <Text>{coverage.name}</Text>}
          </span>
        </li>
      ))}
      {showAll ?
        <Text strong>Asistencias</Text>
        : null
      }
      {assistsSerialized.map((coverage) => (
        <li key={coverage.id} style={{ marginBottom: '5px', display: 'flex' }}>
          <span style={{ width: '30px' }}>
            {coverage.hasThisCoverage ? (
              <FontAwesomeIcon icon={faCheck} style={{ color: SUCCESS_COLOR }} />
            ) : (
              <FontAwesomeIcon icon={faXmark} style={{ color: ERROR_COLOR }} />
            )}
          </span>
          <span>
            {coverage.hasThisCoverage ? (
              <p style={{ margin: 0 }}>
                <Space size='middle'>
                  <Text>{coverage.name}</Text>
                  {showAll && (<>
                    {!!coverage.value && <Text><Text strong>Límite: </Text>{coverage.value}</Text>}
                    {!!coverage.deductible && <Text><Text strong>Deducible: </Text>{coverage.deductible}</Text>}
                  </>)}
                </Space>
              </p>
            ) : <Text>{coverage.name}</Text>}
          </span>
        </li>
      ))}
      {otherCoverages.length > 0 ?
        <Fragment>
          <Text strong>Otras coberturas</Text>
          {otherCoverages.map((coverage) => (
            <li key={coverage.id} style={{ marginBottom: '5px', display: 'flex' }}>
              <span style={{ width: '30px' }}>
                {coverage.hasThisCoverage ? (
                  <FontAwesomeIcon icon={faCheck} style={{ color: SUCCESS_COLOR }} />
                ) : (
                  <FontAwesomeIcon icon={faXmark} style={{ color: ERROR_COLOR }} />
                )}
              </span>
              <span>
                {coverage.hasThisCoverage ? (
                  <p style={{ margin: 0 }}>
                    <Space size='middle'>
                      <Text>{coverage.name}</Text>
                      {showAll && (<>
                        {!!coverage.value && <Text><Text strong>Límite: </Text>{coverage.value}</Text>}
                        {!!coverage.deductible && <Text><Text strong>Deducible: </Text>{coverage.deductible}</Text>}
                      </>)}
                    </Space>
                  </p>
                ) : <Text>{coverage.name}</Text>}
              </span>
            </li>
          ))}
        </Fragment>
        : null
      }
    </ul>
  )
}

ListCoverages.propTypes = {
  coverages: PropTypes.array,
  assists: PropTypes.array,
  showAll: PropTypes.bool,
  insurancePackage: PropTypes.shape({
    id: PropTypes.string,
    package_detail: PropTypes.string,
    coverages: PropTypes.array,
    assists: PropTypes.array,
    payments: PropTypes.array,
  }).isRequired,
};